// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

const WelcomePage = () => import('@/modules/welcome/views/WelcomePage')
const WelcomeScoreboard = () => import('@/modules/welcome/views/WelcomeScoreboard')
const NewOpenerDashboard = () => import('@/modules/openers/views/NewOpenerDashboard')
const NewCloserDashboard = () => import('@/modules/closers/views/NewCloserDashboard')
const NewAdminDashboard = () => import('@/modules/admin/views/NewAdminDashboard')
const NewInstallDashboard = () => import('@/modules/installs/views/NewInstallDashboard')
const WelcomeNewCSDashboard = () => import('@/modules/customer_service/views/NewCSDashboard')
const WelcomeNewRetentionDashboard = () => import('@/modules/customer_service/views/NewRetentionDashboard')
const WelcomeExecutiveDashboard = () => import('@/modules/executive/views/ExecutiveDashboard')

const UserCallbacks = () => import('@/modules/callbacks/views/UserCallbacks')
const Developer = () => import('@/modules/shared/components/Developer')
const ClientSearch = () => import('@/modules/clients/views/ClientSearch')
const ClientDetails = () => import('@/modules/clients/views/ClientDetails')

var routes = [
    {
        path: '/',
        name: 'Home',
        component: DefaultContainer,
        children: [
            {
                path: 'Welcome',
                name: 'Welcome',
                component: WelcomePage,
                meta: {
                    requiresAuth: true,
                    permission: false,
					tab: 'welcome',
                },
				children: [
					{
						path: 'scoreboard',
						name: 'WelcomeScoreboard',
						component: WelcomeScoreboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-scoreboard',
						}
					},
					{
						path: 'openers/new-dashboard',
						name: 'WelcomeNewOpenerDashboard',
						component: NewOpenerDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-opener-new-dashboard',
						},
					},
					{
						path: 'closers/new-dashboard',
						name: 'WelcomeNewCloserDashboard',
						component: NewCloserDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-closer-new-dashboard',
						},
					},
					{
						path: 'admin/new-dashboard',
						name: 'WelcomeNewAdminDashboard',
						component: NewAdminDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-admin-new-dashboard',
						},
					},
					{
						path: 'installs/new-dashboard',
						name: 'WelcomeNewInstallDashboard',
						component: NewInstallDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-installs-new-dashboard',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'customer-service/new-dashboard',
						name: 'WelcomeNewCSDashboard',
						component: WelcomeNewCSDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-cs-dashboard',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'customer-service/new-retention-dashboard',
						name: 'WelcomeNewRetentionDashboard',
						component: WelcomeNewRetentionDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-retention-dashboard',
							role_filter: 'customer_service_agent',
						},
					},
					{
						path: 'executive/dashboard',
						name: 'WelcomeExecutiveDashboard',
						component: WelcomeExecutiveDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'welcome-executive-dashboard',
						},
					},
				]
            },
            {
                path: 'callbacks',
                name: 'UserCallbacks',
                component: UserCallbacks,
                meta: {
                    requiresAuth: true,
                    permission: false,
                }
            },
            {
                path: 'developer',
                name: 'Developer',
                component: Developer,
                meta: {
                    requiresAuth: true,
                    permission: false,
                }
            },
            {
                path: 'client/search',
                name: 'Client Search',
                component: ClientSearch,
				query: {
                    page: 1,
                    query: null
                },
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: 'client/:id',
                name: 'ClientDetails',
                component: ClientDetails,
                meta: {
                    requiresAuth: true,
                },
                props: (route) => ({ clientId: parseInt(route.params.id) })
            }
        ]
    }
];

export default routes;
